import xlr8 from "@/model/xlr8"
import pb from "@/model/pb"

export default {
  xlr8,
  pb
};
